module.exports = __webpack_public_path__ + "static/media/Allahabad Bank.a0c12a42.svg";